import React, { useState, useEffect } from 'react';
import Modal from './Modal';

const Footer: React.FC = () => {
  const [isTermsModalOpen, setTermsModalOpen] = useState(false);
  const [isPrivacyModalOpen, setPrivacyModalOpen] = useState(false);
  const [isAboutModalOpen, setAboutModalOpen] = useState(false);

  const openTermsModal = () => setTermsModalOpen(true);
  const closeTermsModal = () => setTermsModalOpen(false);

  const openPrivacyModal = () => setPrivacyModalOpen(true);
  const closePrivacyModal = () => setPrivacyModalOpen(false);

  const openAboutModal = () => setAboutModalOpen(true);
  const closeAboutModal = () => setAboutModalOpen(false);
  
	useEffect(() => {
	  const handleOpenPrivacy = () => setPrivacyModalOpen(true);
	  const handleOpenTerms = () => setTermsModalOpen(true);
	  const handleOpenAbout = () => setAboutModalOpen(true);

	  window.addEventListener('open-privacy-modal', handleOpenPrivacy);
	  window.addEventListener('open-terms-modal', handleOpenTerms);
	  window.addEventListener('open-about-modal', handleOpenAbout);

	  return () => {
		window.removeEventListener('open-privacy-modal', handleOpenPrivacy);
		window.removeEventListener('open-terms-modal', handleOpenTerms);
		window.removeEventListener('open-about-modal', handleOpenAbout);
	  };
	}, []);

  return (
    <footer>
		<div className="footer-info">
		  <p>
			<a 
			  href="#!" 
			  onClick={(e) => { 
				e.preventDefault(); 
				window.dispatchEvent(new Event('open-terms-modal')); 
			  }}
			>
			  Terms & Legal
			</a>   |   
			<a 
			  href="#!" 
			  onClick={(e) => { 
				e.preventDefault(); 
				window.dispatchEvent(new Event('open-privacy-modal')); 
			  }}
			>
			  Privacy Policy
			</a>   |   
			<a 
			  href="#!" 
			  onClick={(e) => { 
				e.preventDefault(); 
				window.dispatchEvent(new Event('open-about-modal')); 
			  }}
			>
			  About Us
			</a>
		  </p>
		</div>

      <Modal
        showModal={isTermsModalOpen}
        setShowModal={setTermsModalOpen}
        contentLabel=""
      >
		<div className="privacy-container">
			<h1>Terms & Legal</h1>
			<p>By using the <em>WhatIsBetween.com</em> app, you agree to be bound by these terms and conditions. If you do not agree, please do not use the app.</p>
	
			<p>The app provides location-based services using HERE Maps, Google Custom Search Engine, <strong>Google Gemini AI</strong>, and Ticketmaster APIs. It is built with Node.js, React, and Google Cloud-based services.</p>
	
			<p>Users agree to use the app in compliance with all applicable laws and regulations. The app must not be used for illegal activities or in ways that infringe on the rights of others.</p>
	
			<p>Users are granted a non-exclusive, non-transferable license to use the app. Use of third-party services is subject to their respective terms:</p>
			<ul>
				<li><a href="https://developer.here.com/terms-and-conditions" target="_blank">HERE Maps</a></li>
				<li><a href="https://developers.google.com/custom-search/docs/terms" target="_blank">Google Custom Search Engine</a></li>
				<li><a href="https://cloud.google.com/terms/service-terms" target="_blank">Google Gemini AI (Vertex AI)</a></li>
				<li><a href="https://cloud.google.com/terms" target="_blank">Google Cloud</a></li>
				<li><a href="https://developer.ticketmaster.com/products-and-docs/apis/discovery-api/v2/" target="_blank">Ticketmaster</a></li>
			</ul>
	
			<p>Any misuse of these services may result in termination of access.</p>
			<p>The app does not store any personal data, preferences, or user-entered information.</p>
	
			<p>The app is provided “as is” without warranties. The developers are not liable for any damages arising from its use, including inaccuracies in map data, <strong>AI-generated suggestions</strong>, or service disruptions.</p>

			<h3 id="ai-disclaimer">AI-Generated Content & Accuracy</h3>
			<p>Our "AI Search" and "Scout" features use generative artificial intelligence to provide travel recommendations. While we strive for high-quality results, AI-generated content can occasionally be inaccurate, outdated, or include "hallucinations" (information that appears factual but is incorrect).</p>
			<p>Users should independently verify business hours, locations, and suitability before traveling. We are not responsible for any inconvenience, costs, or damages resulting from reliance on AI-generated suggestions.</p>

			<h3>Content Sources & Listings</h3>
			<p><em>What Is Between</em> uses a combination of <strong>editorially curated content</strong>, <strong>algorithmically generated listings</strong>, and <strong>generative AI</strong> to highlight great businesses and destinations along travel routes. These listings may include images and information sourced through custom search tools and AI models to enhance the user experience and support convenient travel planning.</p>
			<p>Images and business details are selected to provide relevant, publicly available information that helps users discover places of interest. We strive to ensure accuracy and relevance, but cannot guarantee completeness or real-time updates.</p>

			<h3>Copyright & Takedown Policy</h3>
			<p><em>What Is Between</em> aims to promote businesses by showcasing publicly available images from their websites to enhance the user experience.</p>
			<p>We display only images that businesses have published on their own websites for promotional purposes. We do not claim ownership of these images.</p>
			<p>Each image links back to its original source, giving credit and directing users to the business’s website.</p>
			<p>Images are displayed as-is, typically as thumbnails or previews, to minimize bandwidth and respect original content.</p>

			<h3>Takedown Requests</h3>
			<p>If you are a copyright holder or authorized representative and believe your content has been used improperly, please email us at <strong>support@somewherehalfway.com</strong> with the subject line: <strong>"Takedown Request"</strong>.</p>
			<p>Please include the following:</p>
			<ul>
				<li>Your full name and contact information</li>
				<li>A description of the copyrighted work</li>
				<li>The URL(s) of the image(s) in question</li>
				<li>A statement of good faith belief that the use is unauthorized</li>
				<li>A statement that the information is accurate and that you are authorized to act on behalf of the copyright owner</li>
			</ul>

			<p><strong>What We Do:</strong></p>
			<ul>
				<li>Review and verify the claim</li>
				<li>Remove or disable access to the image</li>
				<li>Notify the user (if applicable) of the takedown</li>
			</ul>

			<p>All intellectual property rights related to the app and its content are owned by the developers or their licensors.</p>
			<p>We reserve the right to modify these terms at any time. Users will be notified of changes through the app.</p>
			<p>For questions, contact us at: <strong>support@somewherehalfway.com</strong></p>
		</div>
      </Modal>

      <Modal
        showModal={isPrivacyModalOpen}
        setShowModal={setPrivacyModalOpen}
        contentLabel=""
      >
                <div class="privacy-container"> 
					<h1>Privacy Policy</h1>
					<p>This Privacy Policy explains how WhatIsBetween.com ("we", "our", "the app") processes personal data when you use our website.</p>
					<p>We aim to keep things simple and transparent.</p>
					<p>Our platform does not require user accounts and does not run personalised or behavioural advertising based on user tracking, analytics, or profiling technologies.</p>
					<p>Any business or place information shown in the app—including editorially curated content and AI-generated suggestions—is provided as <strong>contextual informational content</strong> based on your specific search query, not targeted advertising derived from your personal browsing history.</p>


					<h2>1. Summary</h2>
					<ul>
						<li>We do not run personalised or behavioural advertising based on user tracking.</li>
						<li>All business listings are contextual to your search and not based on individual profiling.</li>
						<li>We do not use analytics tools that track individuals (e.g., Google Analytics).</li>
						<li>We do not create cookies ourselves.</li>
						<li>We do not collect or store any personal data unless you voluntarily contact us.</li>
						<li>Some third-party images you view may cause the hosting website to set cookies—this is outside our control.</li>
						<li>We display interactive maps using HERE Maps. These maps do not create cookies based on our testing.</li>
						<li><b>AI Search:</b> Your route coordinates and intent are processed by Google Gemini via an enterprise API that does not use your data for training.</li>
						<li>You always remain in control of your location permissions.</li>
					</ul>


					<h2>2. What personal data is processed</h2>
					<p>Although we do not store personal data ourselves, some information is processed automatically as part of normal web operations.</p>

					<h3>2.1 Information processed automatically</h3>
					<p>When you visit the app, Google Cloud Platform (our hosting provider) automatically processes standard server log data (IP address, browser type, and timestamps). We review these logs to monitor performance, diagnose technical issues, and analyze aggregate search trends to improve our service. We do not use this data to identify individuals, track specific users, or create personal profiles.</p>

					<h3>2.2 Location information (optional)</h3>
					<p>If you use the “current location” button, your browser may request permission to access your device location. This data is used to calculate coordinates which are shared with the mapping API for routing and the AI API to generate travel suggestions. We do not store this information.</p>

					<h3>2.3 Search inputs and typed locations</h3>
					<p>When you type a location or place name, the text remains client-side except when sent to APIs to perform searches, map displays, or AI-generated suggestions. We do not store or save your searches ourselves.</p>

					<h3 id="ai-policy">2.4 AI-Augmented Search (Gemini API)</h3>
					<p>When you use our "AI Search" or "Travel Concierge" features, the following logic applies:</p>
					<ul>
						<li><b>Functionality:</b> Your route coordinates (Start, End, and Midpoint) and your typed "User Intent" are sent to Google Gemini (Vertex AI). This is a contractual necessity to provide the travel suggestions.</li>
						<li><b>No-Training Guarantee:</b> We use enterprise-grade Google Cloud Vertex AI. Unlike consumer chatbots, your data is <b>not</b> used by Google to train or improve their Large Language Models (LLMs). Your queries remain private to your session.</li>
						<li><b>Data Minimization:</b> We do not send your personal identity, IP address, or account details to the AI model—only the geographic data and intent string required for the search.</li>
					</ul>

					<h2>3. Third-party services that may process data</h2>
					<p>To provide mapping, routing, search results, and AI suggestions, we use third-party services that may process IP addresses or geolocation coordinates.</p>

					<p>These providers include:</p>
					<ul>
						<li><a href="https://cloud.google.com/terms" target="_blank">Google Cloud Platform (Hosting & Server Logs)</a></li>
						<li><a href="https://cloud.google.com/terms/service-terms" target="_blank">Google Gemini AI (Vertex AI)</a></li>
						<li><a href="https://www.here.com/privacy" target="_blank">HERE Maps API (Maps, Geocoding, Routing)</a></li>
						<li><a href="https://developers.google.com/custom-search/docs/terms" target="_blank">Google Custom Search (Image Search)</a></li>
						<li><a href="https://developer.ticketmaster.com/support/terms-of-use/" target="_blank">Ticketmaster API (Event Data)</a></li>
					</ul>

					<p>We do not use these services for analytics, advertising, or tracking, and we do not intentionally share data for those purposes. Any processing performed by these providers is governed by their own privacy policies.</p>
					<p>Links to third-party sites are provided for convenience. Their privacy policies apply.</p>


					<h2>4. Cookies and similar technologies</h2>


					<h3>4.1 Cookies set by this app</h3>
					<p>We do not set any cookies, tracking pixels, analytics tags, or advertising identifiers.</p>


					<h3>4.2 Cookies set by third-party image hosts</h3>
					<p>Some images in search results are loaded directly from their original websites. Because your browser requests those images from the host site, that external site may set its own cookies.</p>
					<ul>
					<li>These cookies are not created, read, or controlled by us</li>
					<li>They are governed by the privacy policies of the sites that host the images</li>
					<li>They do not affect your use of WhatIsBetween.com</li>
					</ul>


					<h3>4.3 HERE Maps, Google Maps APIs, Google hosting</h3>
					<p>Based on testing, these services do not set cookies during normal use of our app. If this changes, this policy will be updated.</p>


					<h2>5. Legal Basis (GDPR)</h2>
					<p>Under the UK GDPR and EU GDPR, we rely on the following legal bases:</p>

					<h3>Legitimate Interests / Contractual Necessity</h3>
					<ul>
						<li>Operating a simple informational platform.</li>
						<li><b>AI Processing:</b> Sharing coordinates with the AI API is necessary to fulfill the user's specific request for a "Scouted" route.</li>
						<li>Displaying third-party images or maps necessary for the service.</li>
					</ul>


					<h3>Consent</h3>
					<p>Required only when a third-party cookie or service seeks consent. Since our platform does not set such cookies, consent is not required from us. Any cookies set by third-party image hosts fall under their own privacy policies.</p>


					<h3>Contract / Communication</h3>
					<p>If you contact us, we process your information only to respond.</p>


					<h2>6. Data retention</h2>
					<p>We do not store personal data. Third-party service providers retain data according to their own policies, such as Google Cloud’s log retention defaults.</p>


					<h2>7. Changes to this policy</h2>
					<p>If this Privacy Policy is updated, the new version will be published on this page.</p>


					<h2>8. Contact</h2>
					<p>For any questions or concerns, contact:</p>
					<p><strong>support@somewherehalfway.com</strong></p>
                </div>
      </Modal>

      <Modal
        showModal={isAboutModalOpen}
        setShowModal={setAboutModalOpen}
        contentLabel=""
      >
		<div className="privacy-container">
			<h1>About Us</h1>
			<p><strong>WhatIsBetween.com</strong> is designed to help you discover amazing places along your journey—whether you're planning a road trip, meeting halfway with someone, or simply looking for the perfect place to pause.</p>

			<p>We make it easy to find locations that are suitable, convenient, and inspiring—so that distance never gets in the way of connections or new experiences. Whether you're traveling for fun, family, or friendship, we help you uncover hidden gems along the route, and often overlooked or just not found by other platforms.</p>

			<p>Our platform uniquely combines <strong>editorial curation</strong> with <strong>Advanced AI & Intelligence</strong> to act as your digital travel scout. By moving beyond simple keyword searches, our AI-powered "Scout" mode understands the nuances of your trip—helping you find exactly what you're looking for, right where you need it to be.</p>

			<p>We’re committed to continuous innovation, using technology to make travel planning smarter, more equitable, and more enjoyable. We hope you’ll keep exploring, sharing, and discovering with us—because the journey is just as important as the destination.</p>

			<h3>For Businesses & Partners</h3>
			<p><em>WhatIsBetween.com</em> is not only built for travelers—it’s also a platform for businesses looking to connect with audiences on the move.</p>

			<p>We welcome collaborations with hospitality providers, tourism platforms, and destination management companies who see the value in reaching travelers at key moments along their journey. Our AI-driven discovery engine helps showcase local gems in context, connecting the right traveler with the right destination at the perfect time.</p>

			<p>If you believe <em>What Is Between</em> could support your goals or campaigns, we’d love to hear from you. Let’s explore how we can work together to create meaningful experiences and drive discovery.</p>

			<p>Contact us at: <strong>support@somewherehalfway.com</strong></p>
		</div>
		
      </Modal>
    </footer>
  );
};

export default Footer;
